export class UserGroupEntity {
  createdAt?: string
  updatedAt?: string
  deletedAt?: string | null
  id?: number
  name?: string | null
  usersCount?: number
}
